import type { ReactNode } from 'react'
import BoltRoundedIcon from '@mui/icons-material/BoltRounded'
import GroupAddRoundedIcon from '@mui/icons-material/GroupAddRounded'
import SummarizeRoundedIcon from '@mui/icons-material/SummarizeRounded'
import SyncRoundedIcon from '@mui/icons-material/SyncRounded'
import type { MemberAutomationStarterAction } from '../../services/memberControlsService'

// §8.5.9 — the last entry is a redirect to the Invite Hub, not an
// automation. Marking it separately so the UI can render it in a distinct
// "Shortcuts" section instead of pretending it's a runnable job.
export const MEMBER_QUICK_ACTIONS: Array<{
  id: MemberAutomationStarterAction
  title: string
  description: string
  icon: ReactNode
  kind: 'automation' | 'shortcut'
}> = [
  { id: 'DAILY_SYNC', title: 'Daily Sync', description: 'Start a lightweight team sync run.', icon: <SyncRoundedIcon />, kind: 'automation' },
  { id: 'END_OF_DAY_REPORT', title: 'End-of-Day Report', description: 'Generate a closing operational report starter.', icon: <SummarizeRoundedIcon />, kind: 'automation' },
  { id: 'WORKSPACE_CHECK', title: 'Workspace Check', description: 'Run a quick workspace health pulse.', icon: <BoltRoundedIcon />, kind: 'automation' },
  { id: 'INVITE_MEMBER', title: 'Invite Member', description: 'Open the existing Invite Hub.', icon: <GroupAddRoundedIcon />, kind: 'shortcut' },
]
